import { render, staticRenderFns } from "./QuotaholdersOperationsDetailsTable.vue?vue&type=template&id=682c6578&scoped=true&"
import script from "./QuotaholdersOperationsDetailsTable.vue?vue&type=script&lang=js&"
export * from "./QuotaholdersOperationsDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./QuotaholdersOperationsDetailsTable.vue?vue&type=style&index=0&id=682c6578&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682c6578",
  null
  
)

export default component.exports